import { EncodingUtils } from '../EncodingUtils/EncodingUtils';
export class DownloadUtils {
  private constructor() {}
  public static download(fileName: string, obj: Parameters<typeof URL.createObjectURL>[0]): void {
    const objectUrl = URL.createObjectURL(obj);
    const anchor = document.createElement('a');
    anchor.setAttribute('href', objectUrl);
    anchor.setAttribute('download', fileName);
    anchor.click();
    setTimeout(() => {
      URL.revokeObjectURL(objectUrl);
    }, 10);
  }
  public static downloadUtf8AsUtf16le(utf8String: string, fileName: string): void {
    const utf16leCsv = EncodingUtils.utf8ToUtf16LE(utf8String);
    this.download(fileName,
    // any cast because there are some typing issues. Probably there is a mixup between browser + node types
    new Blob([utf16leCsv.buffer as any], {
      type: 'text/plain'
    }));
  }
}